export default __webpack_public_path__ + "static/media/tuepha.b14acf8b.png";